import React, { useEffect } from 'react';
import { Button, Modal, ModalBody, ModalFooter, Form, } from 'reactstrap';
import { isEmpty, pickBy, pick, get, keyBy, omit, mapValues, fromPairs, } from 'lodash';
import { useList, } from 'react-use';
import { addDays, } from 'date-fns';

import { accountItemCategories, } from '../../shared/config';
import useFormState from '../hooks/useFormState';
import Field from '../Field';
import ListForm from '../ListForm';

const { entries, } = Object;

// 科目単位のフィールドを生成
const accountItemFields = (accountItems) => {
  return fromPairs(accountItems.map(_ => {
    const id = _.consolidationAccountItem?.id || _.item?.id;
    const name = _.consolidationAccountItem?.name || _.item?.name;
    return [id, { label: name, type: 'float' }];
  }));
};

// 科目単位のフィールド（円換算あり）を生成
const accountItemFieldsWithJpy = (accountItems, currency) => {
  return accountItems.reduce((x, item) => {
    const id = item.consolidationAccountItem?.id || item.item?.id;
    const name = item.consolidationAccountItem?.name || item.item?.name;
    return {
      ...x,
      [id]: {
        label: name,
        type: 'float',
      },
      ...((currency && currency !== 'jpy') ? {
        [`${id}--jpy`]: {
          label: `${name} (円)`,
          type: 'float',
        },
      } : {}),
    };
  }, {});
};

export default function SsItemFormModal (props) {
  const { isOpen, values, onClickClose, currency, accountItems = [], } = props;
  const fields = {
    ...entries(accountItemFieldsWithJpy(accountItems, currency)).reduce((x, [k, v]) => {
      return {
        ...x,
        [['policyChange', k].join('--')]: {
          ...v,
        },
      };
    }, {}),
  };
  const statedFields = useFormState(values, fields, isOpen);
  const isNew = !values || !values.id;
  const [changeItems, { set: setChangeItems, updateAt: updateChangeItemAt }] = useList(get(values, 'changeItems', []));
  const isUnsubmittable =
    Object.values(statedFields).some(_ => !_.isValid) ||
    (changeItems.some(_ => !_.isValid));
  const onSubmit = async (event) => {
    event.preventDefault();
    if(isUnsubmittable) return;

    props.onSubmit({ ...mapValues(statedFields, 'value'), changeItems: changeItems.map(_ => omit(_, 'isValid')), });
  };

  return (
    <Modal isOpen={isOpen} toggle={onClickClose} style={{ minWidth: '95vw', }}>
      <div className="modal-header">
        <div className="w-100 d-flex justify-content-between">
          <h5 className="modal-title">
            SS編集
          </h5>
        </div>
      </div>
      <Form onSubmit={onSubmit}>
        <ModalBody>
          <div className="mt-4">
            <h5 className="mb-3">
              会計方針の変更による累積的影響額
            </h5>
            <div className="d-flex flex-wrap">
              {
                entries(statedFields).map(([fieldName, fieldSetting]) => (
                  <div key={fieldName} className="mr-2" style={{ width: 160 }}>
                    <Field
                      key={fieldName}
                      name={fieldName}
                      {...fieldSetting}
                    />
                  </div>
                ))
              }
            </div>
          </div>
          <div className="mt-5">
            <h5 className="mb-3">
              当期中の変動額
            </h5>
            <ListForm
              addButtonLabel="行追加"
              items={changeItems}
              renderItem={(changeItem, itemIndex) => {
                return (
                  <div className="card p-3">
                    <ChangeItemForm
                      index={itemIndex}
                      values={changeItem}
                      onChange={_ => updateChangeItemAt(itemIndex, { ...changeItem, ..._, })}
                      currency={currency}
                      accountItems={accountItems}
                    />
                  </div>
                );
              }}
              onChange={setChangeItems}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button className="cancel" color="secondary" onClick={onClickClose}>閉じる</Button>
          <Button className="save" type="submit" color="primary" onClick={onSubmit} disabled={isUnsubmittable}>保存</Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

function ChangeItemForm (props) {
  const { values, onChange, currency, accountItems = [], } = props;
  const fields = {
    label: {
      label: '内容',
      type: 'string',
      validations: {
        required: v => !isEmpty(v),
      },
    },
    ...accountItemFields(accountItems),
    ...((currency && currency !== 'jpy') ? {
      exchangeRate: {
        label: '為替レート',
        type: 'float',
        validations: {
          required: v => v != null && v > 0,
        },
      },
    } : {}),
  };
  const statedFields = useFormState(values, fields, values);
  useEffect(() => {
    onChange({
      ...mapValues(statedFields, 'value'),
      isValid: Object.values(statedFields).every(_ => _.isValid),
    });
  }, [...Object.values(statedFields).map(_ => _.value)]);

  return (
    <div>
      <div className="d-flex flex-wrap">
        {
          entries(statedFields).map(([fieldName, fieldSetting]) => (
            <div key={fieldName} className="mr-2" style={{ width: 160 }}>
              <Field
                key={fieldName}
                name={fieldName}
                {...fieldSetting}
              />
            </div>
          ))
        }
      </div>
    </div>
  );
}
